@use '@/styles/tokens' as *;

.list {
  display: grid;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  margin-bottom: $space-6;
}

.item {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  color: $color-error-900;
  transition: color 160ms ease;
}

.met {
  color: $color-success-900;
}
